import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const survey = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/survey/index.js